import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "./i18n/index.ts"; // 👈 Importa antes que cualquier render
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './auth/AuthContext';
import { WebSocketProvider } from './context/WebSocketContext'; // ✅ Añadir esto
import i18n from "./i18n/index.ts";

document.documentElement.lang = i18n.language;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <WebSocketProvider>          {/* 🔁 Mueve WebSocket aquí */}
      <AuthProvider>
        <App />
      </AuthProvider>
    </WebSocketProvider>
  </React.StrictMode>
);

reportWebVitals();
